import { DeviceOs, DeviceOsValues } from '../../logic/main/types';
import { MEDIUM_BREAKPOINT } from '../modular-grid/constants';

interface MapNavItemsAdditionalData {
  activeCommand?: string;
  mode?: 'default' | 'small' | 'wide';
  width?: number;
  deviceOs?: DeviceOs;
}
export function mapNavItems(
  items: any,
  routes: any,
  additionalData: MapNavItemsAdditionalData = {}
) {
  const filterPredicate = filterOutNavItems(additionalData);
  return items
    .map((item: any) => {
      if (item.routes?.length) {
        const isActive =
          item.routes.some((route: any) => routes.includes(route.route_link)) ||
          routes.includes(item.route_link);

        let routesFromItem = item.routes;
        if (isActive) {
          routesFromItem = routesFromItem.map((itemRoute: any) => ({
            ...itemRoute,
            state: routes.includes(itemRoute.route_link)
              ? 'active'
              : 'inactive',
          }));
        }

        return {
          ...item,
          ...(isActive && { state: 'active' }),
          routes: routesFromItem.filter(filterPredicate),
        };
      }

      const isActive = additionalData.activeCommand
        ? additionalData.activeCommand === item.title
        : routes.includes(item.route_link);

      return { ...item, state: isActive ? 'active' : 'inactive' };
    })
    .filter(filterPredicate);
}

const filterOutNavItems = (additionalData: MapNavItemsAdditionalData = {}) => (
  route: any
) => {
  switch (additionalData.mode) {
    case 'default':
    default: {
      const filterPredicate = getFilterPredicateMap(additionalData);
      return !route.hide_on || route.hide_on.every(filterPredicate);
    }
    case 'small': {
      return !route.hide_on?.includes('Small');
    }
    case 'wide': {
      return !route.hide_on?.includes('Small');
    }
  }
};

const getFilterPredicateMap = (additionalData: MapNavItemsAdditionalData) => (
  filter: string
) => {
  const predicateMap = {
    large: largeScreenFilter,
    small: smallScreenFilter,
    not_windows: notWindowsOsFilter,
  };
  const predicate =
    predicateMap[filter.toLowerCase() as keyof typeof predicateMap] ||
    (() => true);
  return predicate(additionalData);
};

const largeScreenFilter = ({ width }: MapNavItemsAdditionalData) => {
  if (!width) {
    return true;
  }
  return width < MEDIUM_BREAKPOINT.max;
};

const smallScreenFilter = ({ width }: MapNavItemsAdditionalData) => {
  if (!width) {
    return true;
  }
  return width >= MEDIUM_BREAKPOINT.max;
};

const notWindowsOsFilter = ({ deviceOs }: MapNavItemsAdditionalData) => {
  if (!deviceOs) {
    return true;
  }
  return deviceOs === DeviceOsValues.Windows;
};
